import { useEffect, useState } from "react";
import { Navigate, Route, BrowserRouter, Routes } from "react-router-dom";
import "@/App.css";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Layout } from "./components/Layout";
import Login from "./pages/Login";
import POForm from "./pages/POForm";
import POSaved from "./pages/POSaved";
import Register from "./pages/Register";
import Setup from "./pages/Setup";
import GRNForm from "./pages/GRNForm";
import PurchaseReturn from "./pages/PurchaseReturn";
import GRNRegister from "./pages/GRNRegister";
import QuickPO from "./pages/QuickPO";
import Jobs from "./pages/Jobs";
import JobForm from "./pages/JobForm";
import { JobReceiptForm, JobBillForm } from "./pages/JobDocForms";
import { ChallanForm, ChallanReceive, SaleForm } from "./pages/ChallanForms";
import Dashboard from "./pages/Dashboard";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="grid min-h-screen place-items-center text-muted-foreground" data-testid="auth-loading">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const LoginRoute = () => {
  const { user } = useAuth();
  if (user) return <Navigate to="/home" replace />;
  return <Login />;
};

function useThemeClass() {
  const [theme, setTheme] = useState(() => (document.documentElement.classList.contains("dark") ? "dark" : "light"));
  useEffect(() => {
    const obs = new MutationObserver(() => setTheme(document.documentElement.classList.contains("dark") ? "dark" : "light"));
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
    return () => obs.disconnect();
  }, []);
  return theme;
}

function App() {
  const theme = useThemeClass();
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginRoute />} />
          <Route path="/q/:token/*" element={<QuickPO />} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route path="/" element={<Navigate to="/home" replace />} />
            <Route path="/home" element={<Dashboard />} />
            <Route path="/new" element={<POForm key="new" />} />
            <Route path="/pos" element={<Register />} />
            <Route path="/pos/:id/edit" element={<POForm key="edit" />} />
            <Route path="/pos/:id/saved" element={<POSaved />} />
            <Route path="/setup" element={<Setup />} />
            <Route path="/grns" element={<GRNRegister />} />
            <Route path="/jobs" element={<Jobs />} />
            <Route path="/jobs/new" element={<JobForm key="new-job" />} />
            <Route path="/jobs/:id/edit" element={<JobForm key="edit-job" />} />
            <Route path="/jobs/:id/receive" element={<JobReceiptForm />} />
            <Route path="/jobs/:id/bill" element={<JobBillForm />} />
            <Route path="/challans/new" element={<ChallanForm />} />
            <Route path="/sales/new" element={<SaleForm />} />
            <Route path="/challans/:id/receive" element={<ChallanReceive />} />
            <Route path="/pos/:poId/grn/new" element={<GRNForm key="new-grn" />} />
            <Route path="/grns/:grnId/edit" element={<GRNForm key="edit-grn" />} />
            <Route path="/grns/:grnId/return" element={<PurchaseReturn />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" theme={theme} richColors />
    </AuthProvider>
  );
}

export default App;
